export enum AuthErrorMessages {
  NOT_AUTHENTICATED = '[auth] cannot found current authenticated user',
  UNAUTHORIZED = "[auth] user doesn't have permissions to do this action",
}

export class AuthError extends Error {
  constructor(message = AuthErrorMessages.NOT_AUTHENTICATED) {
    super(message);
  }
}



// WEBPACK FOOTER //
// ./src/shared/errors/auth.error.ts